module.exports = __webpack_public_path__ + "img/cover_photo.ecfc121c.jpg";